import { useCallback, useEffect, useState } from 'react';
import { useAccount, useNetwork } from 'wagmi';
import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';
import { onChangeNetwork } from '../../NetworkSelector';
import { getNetworkFlags } from '../../../wallet/helpers';
import { useWallet } from '../../../wallet/walletContext';

const getKeyByValue = (object: Record<string, any>, value: any) =>
  Object.keys(object).find((key) => object[key] === value);

interface ICreateButtonProps {
  createCondition: boolean;
  onCreate(): void;
  label: string;
  chainId?: number;
  isCorrectChain: boolean;
}

const CreateButton = ({
  createCondition,
  onCreate,
  label,
  chainId,
  isCorrectChain,
}: ICreateButtonProps) => {
  const [isNetworkType, setIsNetworkType] = useState(false);
  const [openNetworkLogout, setOpenNetworkLogout] = useState(false);
  const { address } = useAccount();
  const { chain } = useNetwork();
  const { onDisconnect } = useWallet();

  useEffect(() => {
    if (chain?.id && chainId) {
      const userChainFlag = getKeyByValue(getNetworkFlags(chain.id), true);
      const tickerChainFlag = getKeyByValue(getNetworkFlags(chainId), true);

      setIsNetworkType(userChainFlag !== tickerChainFlag);
    }
  }, [chain?.id, chainId]);

  const onChangeChain = useCallback(() => {
    if (isNetworkType) {
      return setOpenNetworkLogout(true);
    }

    if (chainId) {
      onChangeNetwork(chainId);
    }
  }, [chainId, isNetworkType]);

  /**
   * Disconnect user if he wants to switch to not supported network
   */
  const handleDisconnect = useCallback(() => {
    onDisconnect();
    setOpenNetworkLogout(false);
  }, [onDisconnect]);

  return (
    <>
      {isCorrectChain ? (
        <Button
          disabled={createCondition}
          action={onCreate}
          size='m'
          variant='primary'
          aria-label={label}
          text={label}
        />
      ) : (
        <Button
          disabled={!address}
          action={onChangeChain}
          size='m'
          variant='secondary'
          aria-label='Switch network'
          text={isNetworkType ? 'Change network type' : 'Switch network'}
        />
      )}
      {openNetworkLogout && (
        <NetworkLogoutWindow
          onClose={() => setOpenNetworkLogout(false)}
          onDisconnect={handleDisconnect}
        />
      )}
    </>
  );
};

interface INetworkLogoutWindowProps {
  onClose(): void;
  onDisconnect(): void;
}

const NetworkLogoutWindow = ({
  onClose,
  onDisconnect,
}: INetworkLogoutWindowProps) => {
  return (
    <div className='gas__deposit_window'>
      <div
        className='price_alert__backdrop'
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      />
      <div className='price_alert__create' onClick={(e) => e.stopPropagation()}>
        {/* to prevent from chart reacting to clicks */}
        <div className='row'>
          <Text size={14} className='text--grey-200 text--weight-600'>
            Change Network Type
          </Text>
          <div
            className='params_panel__param__property__icon icon-close'
            onClick={() => onClose()}
          />
        </div>
        <div className='price_alert__create__new'>
          <div className='gas priceSelector'>
            <Text size={12} className='text--grey-400'>
              In order to use trading widget on the choosen network you need to
              switch the wallet.
            </Text>
          </div>
          <div className='row'>
            <div className='btnWrapper'>
              <Button
                text='Cancel'
                action={onClose}
                size='s'
                variant='secondary'
              />
            </div>
            <div className='btnWrapper'>
              <Button
                text='Connect'
                action={onDisconnect}
                size='s'
                variant='primary'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateButton;
